module.exports = __webpack_public_path__ + "static/img/app-slide-show5.56c06fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/app-slide-show5.png
// module id = Aslm
// module chunks = 44